import { createContext, useContext } from 'react'

// Tracks which template field element is selected in the rich-text editor, by its stable node id.
// Kept as dedicated React state (not the Slate selection) so it survives focus leaving the editor —
// e.g. while the author types into the field-config toolbar, which would otherwise collapse
// `editor.selection` to null. Mirrors the external-PDF editor's `selectedAttachmentId`.
export interface TemplateFieldSelectionContextValue {
  selectedFieldId: string | null
  setSelectedFieldId: (id: string | null) => void
}

export const TemplateFieldSelectionContext = createContext<TemplateFieldSelectionContextValue>({
  selectedFieldId: null,
  setSelectedFieldId: () => {},
})

export const useTemplateFieldSelection = () => useContext(TemplateFieldSelectionContext)
